import { pgTable, uuid, timestamp, varchar, index } from 'drizzle-orm/pg-core';
import { tenants } from './tenants';

const schema = {
  id: uuid('id').defaultRandom().primaryKey(),
  external_id: uuid('external_id').defaultRandom().notNull().unique(),
  name: varchar('name', { length: 64 }).notNull(),
  description: varchar('description', { length: 256 }),
  tenant_id: uuid('tenant_id').notNull().references(() => tenants.id),
  date_created: timestamp('date_created', { withTimezone: true, mode: 'date' }).defaultNow().notNull(),
  date_modified: timestamp('date_modified', { withTimezone: true, mode: 'date' }).defaultNow().notNull(),
}

/**
 * @ignore
 * @internal
 */
export const roles = pgTable(
  'Roles', 
  schema,
  (table) => [
    index('role_external_id_idx').on(table.external_id),
    index('role_name_idx').on(table.name),
    index('role_tenant_id_idx').on(table.tenant_id),
    index('role_tenant_name_idx').on(table.tenant_id, table.name), // Composite index for tenant + name lookups
  ]
); 